export default __webpack_public_path__ + "static/media/likeIcon.8ca19ac4.svg";